module.exports = __webpack_public_path__ + "img/close.b634bbac.svg";